import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Col
} from "reactstrap";

import axios from "axios";

import { PanelHeader, Button } from "components";

import { thead, tbody } from "variables/general";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";

class BillDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    /* //console.log(props); */
  }
  render() {
    let contentToDisplay = null;
    if(this.props.mainState.ordersArticlesLoaded){
      contentToDisplay = 
      <Col xs={12}>
        <Card> 
            <CardBody>
              <Link to={"/facturas"}>
                <Button
                  color="info"
                  size="sm"
                  /* onClick={e =>
                    this.viewOrderArticles(order.numero_pedido, e)
                  } */
                >
                  <div>
                    <i className="now-ui-icons arrows-1_minimal-left" />   Volver
                  </div>
                </Button>
              </Link>
            </CardBody>     
          <CardHeader>
            <CardTitle tag="h4">Detalle de factura nº {this.props.match.params.orderNumber}</CardTitle>
          </CardHeader>
          <CardBody>
            <Table responsive>
              <thead>
                <tr className="text-primary">
                  <th className="text-left">
                    Concepto
                  </th>
                  <th className="text-center">
                    Precio
                  </th>     
                </tr>
              </thead>
              <tbody>
                {this.props.mainState.ordersArticles[this.props.match.params.orderNumber].map((order, key) => {
                  return (
                    <tr key={key}>
                      <td className="text-left">{order.titulo}</td>
                      <td className="text-center">{order.total}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Col>;
    }else{
      contentToDisplay = 
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title="¡Un momentito!"
        onConfirm={() => this.hideAlert()}
        showConfirm={false}
      >
        <i className="now-ui-icons arrows-1_refresh-69 spin" />
          {"  Cargando artículos de factura..."}
      </SweetAlert>;
    }

    return (
      <div>
        <PanelHeader size="sm" />
        <div className="content">
          <Row>
            {contentToDisplay}
          </Row>
        </div>
      </div>
    );
  }
}

export default BillDetail;



// WEBPACK FOOTER //
// ./src/views/Bills/BillDetail.jsx